
export const setGroups = (groups) => ({
    type: "SET_GROUPS",
    payload: groups,
  });